module.exports = __webpack_public_path__ + "img/151.e3561417.png";